import { useMemo } from 'react';
import { useRideLive } from '../../hooks';
import { scrollY, cardBodySx } from '../../ui/styles';
import { LinearProgress, Stack, Typography } from '../../ui/core';
import MapFirstLayout from '../../components/shared/MapFirstLayout';
import MapErrorBoundary from './MapErrorBoundary';
import RideLiveMap, { riderMarkers } from './RideLiveMap';
import RidePanel from './RidePanel';
import useRide from './useRide';

const ConfirmedRideDetails = ({ id }) => {
  // The same stream the rider's app is on — see RideLiveState.
  const live = useRideLive(id);
  const { ride, status } = useRide(id);
  const riders = useMemo(() => riderMarkers(live.rider, ride?.rider), [live.rider, ride]);

  if (status === 'loading') {
    return (
      <Stack sx={{ ...cardBodySx, position: 'relative', ...scrollY }} alignItems="center">
        <LinearProgress sx={{ width: '300px', marginTop: '300px' }} />
      </Stack>
    );
  }

  if (status === 'notFound') {
    return (
      <Stack sx={cardBodySx} alignItems="center" justifyContent="center" spacing="8px">
        <Typography variant="h5">Ride not found</Typography>
        <Typography color="text.secondary">There is no ride with id {id}.</Typography>
      </Stack>
    );
  }

  if (status === 'error') {
    return (
      <Stack sx={cardBodySx} alignItems="center" justifyContent="center" spacing="8px">
        <Typography variant="h5">Unable to load ride</Typography>
        <Typography color="text.secondary">There was a problem fetching this ride. Please try again.</Typography>
      </Stack>
    );
  }

  return (
    <MapFirstLayout
      map={(sheetPeek) => (
        <MapErrorBoundary>
          <RideLiveMap state={live.state} riders={riders} sheetPeek={sheetPeek} />
        </MapErrorBoundary>
      )}
    >
      <RidePanel ride={ride} live={live} />
    </MapFirstLayout>
  );
};

export default ConfirmedRideDetails;
